import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article16() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });



  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';

      return "";
    }

  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article17');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article15');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article16-left-img1.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">

          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article16-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
          <div className="" ref={firstContainer}>
            <div className="d-inline-block">
              <h3 class="mt-0 mb-0 pb-1 f-lora-i">what’s on</h3>
              <h1 className="fs-xxl mb-0 text-purple">SCOTLAND</h1>
              <h3 class="mt-0 mb-4 mb-sm-5 pb-2 f-lora-i text-end">Autumn-Winter</h3>
            </div>
            <div className="row">
              <div className="col-md-4">
                <h4 className="fs-md mb-3 text-purple">Scottish International Storytelling Festival</h4>
                <h5 className="mb-4 fw-normal text-purple">13th - 29th Oct 2023</h5>
                <p className="mb-3">In Edinburgh’s misty air, the Scottish International Storytelling Festival weaves ancient tales and modern narratives. From local legends to international epics, this cultural feast bridges the old and the new in captivating performances.</p>
                <p className="mb-4 mb-sm-5 text-purple">sisf.org.uk</p>
              </div>
              <div className="col-md-4">
                <h4 className="fs-md mb-3 text-purple">Fort William Mountain Festival </h4>
                <h5 className="mb-4 fw-normal text-purple">15th – 18th Feb 2024</h5>
                <p className="mb-3">In the shadow of Fort William’s towering peaks, the volunteer-led Mountain Festival becomes a magnet for outdoor aficionados. With five days of adrenaline-fueled films, workshops and community engagement, the festival is a Highland highlight not to be missed. </p>
                <p className="mb-4 mb-sm-5 text-purple">mountainfestival.co.uk</p>
              </div>
              <div className="col-md-4">
                <h4 className="fs-md mb-3 text-purple">Glasgow Film Festival</h4>
                <h5 className="mb-4 fw-normal text-purple">24th Feb - 10th Mar 2024</h5>
                <p className="mb-3">From its inception in 2005, Glasgow Film Festival has carved out a space as a major highlight in the UK’s cinematic calendar. Embracing global narratives while championing Scottish cinema, it’s an audience-driven celebration that continues to captivate and grow. </p>
                <p className="mb-4 mb-sm-5 text-purple">glasgowfilm.org</p>
              </div>
            </div>
            
            <div className="row mb-4 mb-sm-5">
              <div className="col-md-5 article16-img-1">
                
              </div>
              <div className="col-md-7 article16-bg">
                <div className="p-4">
                  <h4 className="fs-md mb-3">Edinburgh Christmas Market</h4>
                  <h5 className="mb-4 fw-normal">17th Nov 2023 - 6th Jan 2024</h5>
                  <p className="mb-4 mb-sm-5">As Edinburgh’s skyline twinkles with holiday lights throughout winter, the city promises more than mere ornamentation. Anticipate markets brimming with artisanal gifts, funfair thrills and live spectacles that drew 2.5 million visitors last year.</p>

                  <h4 className="fs-md mb-3">Big Burns Supper Dumfries</h4>
                  <h5 className="mb-4 fw-normal">25th Jan 2024</h5>
                  <p className="mb-3">Amidst the rolling hills of southern Scotland, Big Burns Supper galvanizes culture lovers, near and far. This social co-operative merges art and advocacy, combatting rural isolation while igniting the region’s cultural pulse.</p>
                  <p className="mb-0">bigburnssupper.com</p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <h4 className="fs-md mb-3 text-purple">Aberdeen Jazz Festival </h4>
                <h5 className="mb-4 fw-normal text-purple">Late March 2024 (dates tbc)</h5>
                <p className="mb-3">As musicians and performers flood into the Granite City, a week-long crescendo of jazz and blues engulfs Aberdeen. From spontaneous jam sessions to serene gigs on the green, this festival orchestrates a melodic escape for all.</p>
                <p className="mb-4 mb-sm-5 text-purple">jazzscotland.com</p>
              </div>
              <div className="col-md-4">
                <h4 className="fs-md mb-3 text-purple">Spirit of Speyside Whisky Festival </h4>
                <h5 className="mb-4 fw-normal text-purple">1st - 6th May 2024</h5>
                <p className="mb-3">In Scotland’s renowned Speyside region, the Whisky Festival in May and the Distilled Festival in September provide unparalleled opportunities to explore world-class distilleries through tastings, tours and expertled talks. </p>
                <p className="mb-4 mb-sm-5 text-purple">spiritofspeyside.com</p>
              </div>
              <div className="col-md-4">
                <h4 className="fs-md mb-3 text-purple">Beltane Fire Festival</h4>
                <h5 className="mb-4 fw-normal text-purple">4th May 2024</h5>
                <p className="mb-3">As fire dances in the night sky, Beltane Fire Festival reignites ancient Celtic rituals in a modern blaze of community and celebration. Venture through a kaleidoscope of performances and communal joy, all culminating in the pyre’s exhilarating spark. </p>
                <p className="mb-4 mb-sm-5 text-purple">beltane.org</p>
              </div>
            </div>

          </div>

          </div>
        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article16;
